import React, { useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import FeatherIcon from 'feather-icons-react';
import { useDispatch } from 'react-redux';

import UploadIcon from '../assets/img/upload-icon.svg';
import { downloadManualARNTemplate } from '../Actions/downloadArnAction';
import { saveManualArnAuth } from '../Actions/AuthorizationAction';
import { getData } from '../Actions/landingAction';
import Loader from './Common/loader';

export default function ManualARNUpload({ showManualModal, setShowManualModal }) {
    const dispatch = useDispatch();
    const fileTypes = ['JPG', 'PNG', 'JPEG', 'PDF'];
    const maxFileSizeMB = 5;

    const [loader, setLoader] = useState(false);
    const [fileUpLoaded, setFileUpLoaded] = useState(null);
    const [fileSize, setFileSize] = useState(null);
    const [showFileError, setShowFileError] = useState(false);

    const handleChange = (file) => {
        setShowFileError(false);
        setFileUpLoaded(file);
        setFileSize(file.size);
    };

    const handleSizeError = () => {
        alert('File size is larger than 5 MB');
        setFileUpLoaded(null);
        setFileSize(null);
    };

    const handleDownload = (e) => {
        e?.preventDefault();
        dispatch(downloadManualARNTemplate());
    };

    const handleSubmit = (e) => {
        e?.preventDefault();

        if (fileUpLoaded && fileSize) {
            setShowFileError(false);
            setLoader(true);
            dispatch(saveManualArnAuth({ arn: fileUpLoaded }, uploadResponse));
        } else {
            setShowFileError(true);
        }
    };

    const uploadResponse = async (data) => {
        setLoader(false);
        if (data) {
            await dispatch(getData());
            setShowManualModal(false);
        }
    };

    return (
        <>
        {loader && <Loader/>}
            <div className={`dashboard custom-modal-dialog ${showManualModal ? 'show' : ''}`} id="authorizeBgvPopup">
                <div className="modal-wrapper authorization-modal">
                    <div className="modal-content p-4" id="authorization-modal" style={{ overflow: 'scroll' }}>
                        <h3 className="fnt-smi-bld mb-3 auth-header">Upload Individual’s Authorization</h3>

                        <div className="text-wrapper-modal" style={{ height: 'auto' }}>
                            <p className="text-muted">
                                <strong>Please note:</strong> AuthBridge will be conducting your employment background verification on behalf of your employer.
                                Given below is the button to download the Authorization letter.
                                Please download and hand-sign the document to authorize for your background verification.
                                After hand-signing the document, you must upload it using the button provided below.
                                You have the right to deny and not sign the Authorization letter if you do not want to allow for verification.
                                You are also required to go through our
                                <a href="https://ibridge.authbridge.com/home/privacy-policy/" target="_blank" rel="noreferrer">
                                    {" "}
                                    Privacy policy
                                </a>.
                            </p>
                        </div>

                        <p className="text-primary cursor-pointer" style={{ width: "fit-content" }} onClick={handleDownload}>
                            <FeatherIcon icon="download" className="mr-2" />
                            Download ARN Template
                        </p>

                        <div className="tab-content safari_only p-3" id="myTabContent">
                            <div
                                className="common-white-box d-flex align-items-center justify-content-center flex-column kih-drap-drop"
                                style={{ minHeight: '180px' }}
                            >
                                <img src={UploadIcon} alt="Upload Icon" className="mb-2" />

                                <div className="text-center px-2">
                                    <FileUploader
                                        handleChange={handleChange}
                                        name="file"
                                        maxSize={maxFileSizeMB}
                                        onSizeError={handleSizeError}
                                        types={fileTypes}
                                    />
                                    {fileUpLoaded && <h6 className="mt-2">{fileUpLoaded.name}</h6>}
                                    <span className="text-muted d-block mt-1">
                                        PNG, JPG, JPEG, PDF (max. {maxFileSizeMB}Mb)
                                    </span>
                                    {showFileError && <span className="text-danger">Please upload a file</span>}
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-4">
                            <button className="btn btn-primary btn-lg" onClick={handleSubmit}>
                                Accept &amp; Continue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
